import { useQuery } from '@tanstack/react-query';
import { getVoiceFilters } from '@/api/voice';
import React from 'react';

interface VoiceFilters {
	accents?: string[];
	languages?: string[];
	genders?: string[];
	providers?: string[];
}

export const useVoiceFilters = () => {
	const { data, isPending, refetch } = useQuery<VoiceFilters>({
		queryKey: ['voiceFilters'],
		queryFn: getVoiceFilters,
		staleTime: 1000 * 60 * 60, // 1 hour
		refetchOnWindowFocus: false,
		refetchOnMount: false,
	});

	// Process the data to extract unique values
	const uniqueValues = React.useMemo(() => {
		return {
			accent: data?.accents || [],
			language: data?.languages || [],
			gender: data?.genders || [],
			provider: data?.providers || [],
		};
	}, [data]);

	return {
		uniqueValues,
		isPending,
		refetch,
	};
};
